import React from 'react';
import {Dropdown,DropdownMenu , DropdownToggle, Input, FormGroup,FormFeedback, Label,DropdownItem  } from 'reactstrap';
import $ from 'jquery';
import { connect } from 'react-redux'

class ValidatedSelect extends React.Component {
    constructor(props) {
        super(props);

        this.setState({ valid: false, errorMessage : "Please enter a valid value." })
    }

    componentDidUpdate(prevProps){
        if(this.props.documentTypes !== prevProps.documentTypes)
            this.setState({
                documentTypes: this.props.documentTypes
            })
    }

    validate(inputValue)
    {
        if(this.props.mandatory)
        {
            if(inputValue)
            {
                this.setState({ inputCls: 'is-valid', valid: false,errorMessage : ""})
                return true;
            }
            else
            {
                this.setState({ inputCls: 'is-invalid', valid:true ,errorMessage : "Please enter a valid value"})
                return false;
            }
        }
        else
        {
            this.setState({ inputCls: 'is-valid', valid: false,errorMessage : ""})
            return true;
        }
    }
    
    render() {

        const { localisation } = this.props.userReducer;

        var style = {};
        style.display = 'none';

        let resources = []
          
        //support localization for the default item
        resources.push(<option>{localisation['default_select_text'] ? localisation['default_select_text'].element_lang : 'Select ...'}</option>)

        if(this.props.options){
            this.props.options.forEach(res => {
                if(this.props.customType)
                    resources.push(<option>{res[this.props.customType]}</option>)
                else
                    resources.push(<option>{res}</option>)
            });
        }

        return (<FormGroup>
            <Label for="selectItem" className="s-field-title s-anchored">{this.props.labelText}</Label>
            <Input type="select" name={this.props.name} onChange={this.props.handleDropdownChange} >
                {/*<option value="">{"Select ..."}</option>*/}
                {resources}
            </Input>
        </FormGroup>);
    }
};

export default connect(state => state)(ValidatedSelect); 